import type { CSSProperties } from 'react';
import type { CoverImageProps } from './CoverImage.types';

/**
 * Web override of `CoverImage`. Renders a plain `<img>` so the image
 * carries a real `alt` attribute (expo-image drops it on web, failing
 * the image-alt A11y/SEO audits) and so the LCP hero paints straight
 * from the DOM instead of waiting on expo-image's JS wrapper.
 */
export function CoverImage({ uri, alt, fill, priority, loading = 'eager' }: CoverImageProps) {
  const style: CSSProperties = fill
    ? { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }
    : { display: 'block', width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' };

  return (
    <img
      src={uri}
      alt={alt}
      loading={loading}
      decoding="async"
      // `fetchpriority` is honoured by browsers on <img>; only emit the
      // high hint (the LCP hero) so we don't deprioritise everything else.
      {...(priority === 'high' ? { fetchPriority: 'high' as const } : {})}
      style={style}
    />
  );
}
